import { defineStore } from 'pinia'
import { loadExternalScript } from '../shared/utils';

export const useGlobalStore = defineStore('global', {
  state: () => ({
    _paymentsLoaded: false,
  }),
  actions: {
    loadPaymentsSdkScript() {
      if (!this._paymentsLoaded) {
        if (window['_EZCL']?.sdkUrl) {
          loadExternalScript(window['_EZCL']?.sdkUrl)
          .then((data) => {
            this._paymentsLoaded = true
            console.log('🍀 Payments: loaded');
          })
          .catch((data) => {
            console.warn('🍀 Payments: not loaded, ', data);
          });
        }
      }
    }
  }
})